function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
/* global process */
// eslint-disable-next-line no-underscore-dangle
var __DEV__ = process.env.NODE_ENV !== 'production';
var dummyWrapper = function dummyWrapper(func) {
  return function (state, action) {
    return func(state, action);
  };
};
var catchAll = new RegExp('.+');
/*
handlers is an object with the following format:
'ACTION': reducerFunction(state, value) => nextState,

if ACTION contains *, it will be replaced by a regexp function '.+'.
if ACTION is $defaultState that state will be used initially for that key, if it's not defined on initialState.
all other ACTION starting with '$' will be ignored
 */
function createReducer(initialState, handlers, wrapper) {
  if (__DEV__) {
    if (handlers.undefined) {
      console.warn("Reducer contains an 'undefined' action type. Have you misspelled a constant?");
    }
    if (wrapper && typeof wrapper !== 'function') {
      console.warn("You passed a wrapper parameter to createReducer, but it's not a function.");
    }
    Object.keys(handlers).forEach(function (key) {
      if (typeof handlers[key] !== 'function' && _typeof(handlers[key]) !== 'object') {
        console.warn("You passed a value for the ".concat(key, " action that is not a function nor an object."));
      }
    });
  }
  var internalInitialState = _objectSpread({}, initialState);
  var internalHandlers = Object.keys(handlers).filter(function (handlerKey) {
    return handlerKey[0] !== '$';
  }).map(function (handlerKey) {
    var matchString = handlerKey.replace(/\*/g, '.+');
    var reducer = handlers[handlerKey];
    var re = null;
    if (_typeof(reducer) === 'object') {
      re = catchAll;
      if (!internalInitialState[handlerKey] && reducer.$defaultState !== undefined) {
        internalInitialState[handlerKey] = reducer.$defaultState;
      }

      // eslint-disable-next-line no-use-before-define
      var subReducer = createSubReducer(handlerKey, internalInitialState[handlerKey], reducer, wrapper);
      reducer = subReducer['*'];
    }
    if (typeof reducer !== 'function') {
      throw new Error("Reducer for ".concat(handlerKey, " is not a function. got a ").concat(_typeof(reducer), "."));
    }
    return {
      match: re || new RegExp("^".concat(matchString, "$")),
      reducer: reducer
    };
  });
  var internalWrapper = wrapper || dummyWrapper;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return internalHandlers.reduce(function (currentState, _ref) {
      var match = _ref.match,
        reducer = _ref.reducer;
      return match.test(action.type) ? internalWrapper(reducer)(currentState, action) : currentState;
    }, state);
  };
}
/*
options object:
{ key: 'string', prefix: 'string', suffix: 'string' }

if options is an string, it assumes key is that value and everything else is ''.

prefix will be prepended to each handler action and suffix will be appended.
*/
export function createSubReducer(options, initialState, handlers, wrapper) {
  var key = '';
  var prefix = '';
  var suffix = '';
  if (typeof options === 'string') {
    key = options;
  } else {
    key = options.key;
    prefix = options.prefix || '';
    suffix = options.suffix || '';
  }
  if (typeof key !== 'string' || key.length <= 0) {
    throw new Error('key option must be a non-empty string');
  }
  if (typeof prefix !== 'string') {
    throw new Error('prefix option must be ommited or a string');
  }
  if (typeof suffix !== 'string') {
    throw new Error('suffix option must be ommited or a string');
  }
  var internalHandlers = {};
  Object.keys(handlers).forEach(function (handlerKey) {
    var newKey = "".concat(prefix).concat(handlerKey).concat(suffix);
    internalHandlers[newKey] = handlers[handlerKey];
  });
  var reducer = createReducer(initialState, internalHandlers, wrapper);
  var subReducer = function subReducer(state, action) {
    var subState = state[key] || initialState;
    var nextSubState = reducer(subState, action);
    if (nextSubState === subState) return state;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, nextSubState));
  };
  var MatchObject = "".concat(prefix, "*").concat(suffix);
  return _defineProperty({}, MatchObject, subReducer);
}
export var objectActionHandler = function objectActionHandler(func) {
  return function (state, action) {
    return _objectSpread(_objectSpread({}, state), func(state, action));
  };
};
export var arrayActionHandler = function arrayActionHandler(func) {
  return function (state, action) {
    return state.concat(func(state, action));
  };
};
export default createReducer;